import { createAction, props } from '@ngrx/store';

export const openVerifyUserIdentity = createAction(
  '[VerifyUserIdentity Page] open verification identity modal',
  props<{
    action: {
      data?: any;
      key: string;
    };
  }>(),
);

export const initVerifyUserIdentity = createAction(
  '[VerifyUserIdentity Page] Init',
  props<{ password: string }>(),
);

export const loadVerifyUserIdentitySuccess = createAction(
  '[VerifyUserIdentity/API] Load VerifyUserIdentity Success',
);

export const loadVerifyUserIdentityFailure = createAction(
  '[VerifyUserIdentity/API] Load VerifyUserIdentity Failure',
  props<{ error: any }>(),
);
